import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { History } from 'history'

import { selectUser } from '../../../reducers'
import { updateAddress, fetchUser } from '../userActions'
import { UserBanner } from '../userBanner'
import UserAddressForm from './userAddressForm'
import { User } from '../../../core/types'

interface Params {
  addressId: string
  userId: string
}

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface Props {
  updateAddress: Callback<Promise<any>>
  fetchUser: Callback
  user: User
  match: Match<Params>
  history: History
}

export class UserAddressEdit extends Component<Props> {
  static displayName = 'UserAddressEdit'

  componentWillMount() {
    const { fetchUser, match } = this.props
    fetchUser(match.params.userId)
  }

  onSubmit = (values) => {
    const { updateAddress, history } = this.props
    const createAddressInput = Object.assign({}, values)
    delete createAddressInput.createdAt
    delete createAddressInput.vehicleTaxRate
    return updateAddress(createAddressInput).then(() => {
      history.goBack()
    })
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const { user, match } = this.props
    if (isEmpty(user)) return null

    const addressId = match.params.addressId
    const existingAddress = user.addresses.find((address) => {
      const matchingAddress = address.id === addressId ? address : null
      return matchingAddress
    })

    return (
      <div className="create-address">
        <UserBanner address={user.currentAddress} context="User" user={user} />
        <UserAddressForm
          initialValues={existingAddress}
          onSubmit={this.onSubmit}
          cancel={this.onCancel}
          title="Edit an Address"
        />
      </div>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    user: selectUser(state.users, match.params.userId),
  }
}

export default connect(mapStateToProps, { fetchUser, updateAddress })(
  UserAddressEdit
)
